export const PaletteTab = {
  TRIGGERS: 0,
  INTEGRATIONS: 1,
  TOOLS: 2,
  CUSTOM: 3,
};
